export default __webpack_public_path__ + "static/media/map.469e032d.svg";